var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_4793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.55396 17.4944C8.70019 17.7476 8.91052 17.958 9.1638 18.1042C9.41707 18.2504 9.70437 18.3274 9.99683 18.3274C10.2893 18.3274 10.5766 18.2504 10.8299 18.1042C11.0831 17.958 11.2935 17.7476 11.4397 17.4944",
    stroke: "#F5F5F5",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71741 12.7676C2.60858 12.8869 2.53676 13.0352 2.51069 13.1945C2.48462 13.3539 2.50541 13.5174 2.57055 13.6651C2.63568 13.8129 2.74235 13.9385 2.87757 14.0267C3.0128 14.115 3.17075 14.162 3.33221 14.1621H16.6613C16.8227 14.1622 16.9807 14.1153 17.116 14.0273C17.2513 13.9392 17.3581 13.8137 17.4234 13.6661C17.4888 13.5184 17.5097 13.355 17.4839 13.1956C17.458 13.0362 17.3864 12.8878 17.2777 12.7684C16.1698 11.6263 14.9951 10.4125 14.9951 6.66454C14.9951 5.33888 14.4685 4.06752 13.5312 3.13014C12.5938 2.19275 11.3224 1.66614 9.99675 1.66614C8.67109 1.66614 7.39973 2.19275 6.46234 3.13014C5.52496 4.06752 4.99835 5.33888 4.99835 6.66454C4.99835 10.4125 3.82289 11.6263 2.71741 12.7676Z",
    stroke: "#F5F5F5",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_4793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9936,
    height: 19.9936,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.bf7efa2c1e553b3240eb27f31ead98e9.svg";
export { ForwardRef as ReactComponent };